<template>
  <div class="container-main-body">
    <!--按钮开始-->
    <div class="list-container">
      <div class="list-btns-container">
        <el-button-group>
          <el-button v-for="btn in $store.state.currentLBtnList" :key="btn.id" :type="btn.button_type" size="mini" :icon="btn.button_icon" @click="handlerButtonDispatch(btn.fn)">{{btn.button_name}}</el-button>
        </el-button-group>
      </div>
    </div>
    <!--按钮结束-->
    <!--列表数据 开始-->
    <div class="el-table-container">
      <el-table :data="ds" size="mini" stripe border height="100%" style="width: 100% border:1px solid #d1d1d1" header-row-class-name="list-header-row" row-class-name="list-row" @selection-change="selectHandler">
        <el-table-column type="selection" width="40" align="center" :selectable="selectableHandler"></el-table-column>
        <el-table-column label="角色名称" prop="role_name" width="300" align="center"></el-table-column>
        <el-table-column label="角色描述" prop="description" header-align="center"></el-table-column>
        <el-table-column label="操作" width="50" align="center" fixed="right">
          <template v-slot:default="scope">
            <el-button type="primary" size="mini" icon="el-icon-edit" circle plain @click.stop.prevent="viewHandler(scope.row)"></el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-container">
      <el-pagination background :current-page="query.pn" :page-size="query.pageSize" :total="query.totalCount" :page-sizes="[10, 15, 20, 25, 30, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChange"
        @current-change="pageChange"
      ></el-pagination>
    </div>
    <!--列表数据 结束-->
    <role-dialog-form ref="DForm" :parent="this"></role-dialog-form>
    <!-- 新增表单对话框 -->
  </div>
</template>

<script>
import RoleDialogForm from '@/views/modules/authority/role/Form'
export default {
  data: function () {
    return {
      ds: [],
      delIds: [],
      // 分页
      query: {
        pageSize: 20, // 每页条数
        totalCount: 0, // 数据总条数
        pn: 1 // 页码
      },
      operator_id: sessionStorage.getItem('operator_id')
    }
  },
  mounted: function () {
    this.loadData()
  },
  methods: {
    // 按钮 点击 调度方法
    handlerButtonDispatch: function (fn, args) {
      var _this = this
      if (typeof _this[fn] === 'function') {
        _this[fn].apply(_this, args)
      } else {
        console.log('warning: the method is not exist')
      }
    },
    // 加载数据
    loadData: function () {
      let _this = this
      _this.post(_this.$apis.getRoles, this.query, function (res) {
        let _json = res.data
        if (_json.status && _json.status === 'logout') {
          _this.logout()
        } else {
          _this.ds = _json.datalist
          _this.query.totalCount = _json.totalCount
        }
      })
    },
    // 多选事件
    selectHandler: function (selection) {
      this.delIds = []
      for (let i = 0; i < selection.length; ++i) {
        this.delIds.push(selection[i].id)
      }
    },
    // 刷新事件
    refreshHandler: function () {
      this.loadData()
    },
    // 新增
    addHandler: function () {
      this.$refs.DForm.addHandler()
    },
    // 删除
    delHandler: function () {
      let _this = this

      if (_this.delIds.length === 0) {
        _this.$message({
          type: 'warning',
          message: '至少选择一条数据'
        })
      } else {
        _this
          .$confirm('此操作将永久删除该条数据, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            // ajax提交至服务器，删除数据
            _this.post(_this.$apis.delRoles, { ids: _this.delIds.join(','), operator_id: _this.operator_id }, function (res) {
              let _json = res.data
              if (_json.status === 'ok') {
                _this.loadData()
                _this.$message({
                  type: 'success',
                  message: '删除成功!'
                })
              } else {
                _this.$message({
                  type: 'error',
                  message: '无数据更新!'
                })
              }
            })
          })
          .catch(() => {
            _this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
      }
    },
    // 浏览
    viewHandler: function (_row) {
      let formId = _row.id
      this.$refs.DForm.editHandler(formId)
    },
    // 页码改变
    pageSizeChange: function (pageSize) {
      this.query.pn = 1
      this.query.pageSize = pageSize
      this.loadData()
    },
    pageChange: function (pn) {
      this.query.pn = pn
      this.loadData()
    },
    // 通过该方法，控制列表 checkbox 列是否允许勾选
    selectableHandler: function (_row, _index) {
      let operatorId = sessionStorage.getItem('operator_id')
      let createrId = _row.creater_id
      let delable = this.$store.state.delable
      // 函数需要一个返回值,true为可选,false为不可选择
      return (operatorId === createrId || delable === '是')
    }
  },
  components: {
    RoleDialogForm
  }
}
</script>
